<template>
  <div class="page-container">
    <div class="header">
      <div class="title">订单管理</div>
    </div>
    <div class="search-form">
      <el-form
        class="search-form-content"
        inline
        :model="form"
        label-width="100px"
        label-position="left">
        <el-row>
          <el-col>
            <el-form-item label="支付时间" size="small">
              <div class="time-range-content">
                <div class="quick-time-picker">
                  <div
                    :class="['item', {active: activeIndex === index}]"
                    v-for="(item, index) in timeQuickPickerList"
                    :key="index"
                    @click="handleQuickTimePickerChange(index)"
                  >{{ item }}
                  </div>
                </div>
                <el-date-picker
                  v-model="dateTimeRange"
                  :picker-options="pickerOptions"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                  @change="handleTimeRangeChange"
                  align="right"
                  size="small"/>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="支付码" size="small">
              <el-input v-model="form.paymentCode" placeholder="请输入支付码" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="订单状态" size="small">
              <el-select v-model="form.status" placeholder="请选择交易类型" clearable>
                <el-option v-for="(item, index) in statusOptions" :value="item.value" :key="index" :label="item.label"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="订单号" size="small">
              <el-input v-model="form.orderId" placeholder="请输入订单号" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item size="small">
              <el-button :loading="exportLoading" @click="exportTable()" class="bs-btn2">导出</el-button>
              <el-button @click="handleFormReset" class="bs-btn2">重置</el-button>
              <el-button type="primary" @click="handleFormSearch" class="bs-btn">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="table-container">
      <el-table :data="table.data" style="width: 100%;" border v-loading="table.loading">
        <el-table-column prop="paymentCode" label="支付码" align="center" min-width="150px"/>
        <el-table-column prop="orderId" label="订单号" align="center" min-width="150px"/>
        <el-table-column prop="depositAmountStr" label="押金" align="center" min-width="150px"/>
        <el-table-column prop="totalAmountStr" label="订单总金额" align="center" min-width="150px"/>
        <el-table-column prop="refundAmountStr" label="退款" align="center" min-width="150px"/>
        <el-table-column prop="payTime" label="支付时间" align="center" min-width="150px"/>
        <el-table-column
          prop="preProcessStatus"
          label="订单状态"
          align="center"
          min-width="150px"
          :formatter="formatStatus"
          v-if="refreshTable"/>
        <el-table-column label="操作" align="center" fixed="right" min-width="200px" v-if="refreshTable">
          <template slot-scope="{row, $index}">
            <el-button
              type="text"
              @click="handleTableRefresh(row, $index)"
              v-if="row.preProcessStatus === 3"
              :loading="loadingObj[row.orderId]">{{ loadingObj[row.orderId] ? '处理中' : '刷新' }}
            </el-button>
            <el-button type="text" @click="handleTableDetail(row, 1)">查看详情</el-button>
            <el-button type="text" @click="handleTableDetail(row, 0)" v-if="row.checkOutFlag === 1">退订</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-content">
        <el-pagination
          v-if="table.totalCount > 0"
          :page-size="table.pageSize"
          :layout="'total, prev, pager, next, jumper'"
          :total="table.totalCount"
          :current-page="table.pageNo"
          @current-change="onChangeCurrentPage"/>
      </div>
    </div>
    <el-dialog :visible.sync="showDetailDialog" width="800px" class="dialog-wrap">
      <div class="title" slot="title">详情</div>
      <div v-loading="detailLoading">
        <el-row class="row el-row--flex is-align-middle">
          <el-col :span="16" class="el-row--flex is-align-middle">
            <label class="label">订单号</label>
            <span class="value">
            <span id="businessNo">{{ detailForm.orderId }}</span>
            <copy-btn v-if="detailForm.orderId" id="#businessNo"/>
          </span>
          </el-col>
          <el-col :span="8" class="el-row--flex is-justify-space-between">
            <label class="label">订单状态</label>
            <span class="value">{{ detailForm.statusStr }}</span>
          </el-col>
        </el-row>
        <el-row class="row el-row--flex is-align-middle">
          <el-col :span="16" class="el-row--flex is-align-middle">
            <label class="label">订单创建时间</label>
            <span class="value">{{ detailForm.createTime }}</span>
          </el-col>
          <el-col :span="8" class="el-row--flex is-justify-space-between">
            <label class="label">支付码</label>
            <span class="value">{{ detailForm.paymentCode }}</span>
          </el-col>
        </el-row>
        <el-divider/>
        <el-row class="row el-row--flex is-align-middle">
          <el-col :span="16" class="el-row--flex is-align-middle">
            <label class="label">交易订单号</label>
            <span class="value">
            <span id="originBusinessOrderNo">{{ detailForm.lsOrderId }}</span>
            <copy-btn v-if="detailForm.lsOrderId" id="#originBusinessOrderNo"/>
          </span>
          </el-col>
          <el-col :span="8" class="el-row--flex is-justify-space-between">
            <label class="label">交易类型</label>
            <span class="value">{{ detailForm.tradeTypeStr }}</span>
          </el-col>
        </el-row>
        <el-row class="row el-row--flex is-align-middle">
          <el-col :span="16" class="el-row--flex is-align-middle">
            <label class="label">交易流水号</label>
            <span class="value">
            <span id="merchantOrderId">{{ detailForm.lsFlowId }}</span>
            <copy-btn v-if="detailForm.lsFlowId" id="#merchantOrderId"/>
          </span>
          </el-col>
          <el-col :span="8" class="el-row--flex is-justify-space-between">
            <label class="label">支付方式</label>
            <span class="value">{{ detailForm.payTypeStr }}</span>
          </el-col>
        </el-row>
        <el-row class="row el-row--flex is-align-middle">
          <el-col :span="16" class="el-row--flex is-align-middle">
            <label class="label">交易时间</label>
            <span class="value">{{ detailForm.payTime }}</span>
          </el-col>
          <el-col :span="8" class="el-row--flex is-justify-space-between">
            <label class="label">支付状态</label>
            <span class="value">{{ detailForm.payStatusStr }}</span>
          </el-col>
        </el-row>
        <el-divider/>
        <div class="title">明细</div>
        <el-table border stripe :header-cell-style="{background: '#EFF4F8'}" :data="detailTable">
          <el-table-column label="押金（元）" prop="depositAmountStr" align="center"/>
          <el-table-column label="订单总额（元）" prop="totalAmountStr" align="center"/>
          <el-table-column label="已退（元）" prop="refundAmountStr" align="center"/>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="showRefundDialog"
      width="800px"
      class="dialog-wrap"
      @close="handleCancelRefund"
      :close-on-click-modal="false">
      <div class="title" slot="title">退订</div>
      <div v-loading="detailLoading">
        <el-row class="row el-row--flex is-align-middle">
          <el-col :span="16">
            <label class="label">订单号</label>
            <span class="value">
            <span id="businessNo1">{{ detailForm.orderId }}</span>
            <copy-btn v-if="detailForm.orderId" id="#businessNo1"/>
          </span>
          </el-col>
          <el-col :span="8" class="el-row--flex is-justify-space-between is-align-middle">
            <label class="label">订单状态</label>
            <span class="value">{{ detailForm.statusStr }}</span>
          </el-col>
        </el-row>
        <el-row class="row el-row--flex is-align-middle">
          <el-col :span="16">
            <label class="label">订单创建时间</label>
            <span class="value">{{ detailForm.createTime }}</span>
          </el-col>
          <el-col :span="8" class="el-row--flex is-justify-space-between is-align-middle">
            <label class="label">支付码</label>
            <span class="value">{{ detailForm.paymentCode }}</span>
          </el-col>
        </el-row>
        <el-form label-width="160px" class="form-wrap" :model="refundForm" :rules="formRules" ref="refundForm">
          <el-form-item label="押金（元）：">{{ refundForm.depositAmountStr }}</el-form-item>
          <el-form-item label="退还客户金额（元）：" prop="refundAmount">
            <el-input v-model="refundForm.refundAmount" placeholder="请输入应退还的押金金额"/>
          </el-form-item>
          <el-form-item label="剩余扣除（元）：">{{ remainMoney }}</el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <div v-if="refundBtnLoading" style="margin-bottom: 20px;color: red; text-align: right;">处理中，请勿关闭窗口</div>
        <el-button @click="handleCancelRefund">取消</el-button>
        <el-button type="primary" @click="handleConfirmRefund" :loading="refundBtnLoading">
          {{ refundBtnLoading ? '处理中' : '确认' }}
        </el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="notify.show" width="400px" title="提示" @close="handleCancelNotify" top="0">
      <i :class="`el-icon-${notify.type}`" :style="{color: notify.color}"></i>
      <span style="margin-left: 10px;">{{notify.message}}</span>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import copyBtn from '../../components/CopyBtn/copy-btn.vue';
import {
  debounce,
} from "@/utils/index";
import {
  pageQuery, exportOrder, queryOrderDetail, refundOrder, getOperateRefundResult, refreshOrderStatus,
} from '@/api/advance-payment';

const FORMAT = 'yyyy-MM-DD HH:mm:ss';
const startDate = moment().startOf('d').format(FORMAT);
const endDate = moment().endOf('d').format(FORMAT);
const defaultTime = [startDate, endDate];

export default {
  name: "advance-payment-index",
  components: {
    copyBtn,
  },
  data() {
    const validRefundAmount = (rule, value, callback) => {
      const reg = /^((\d)*|([0]{1}))(.(\d){0,2})?$/;
      if (!value) {
        callback(new Error('请输入押金金额'));
      } else if (+value < 0 || !reg.test(value)) {
        callback(new Error('输入金额有误'));
      } else if (+value > +this.refundForm.depositAmountStr) {
        callback(new Error('输入的金额数值超过最大值，请重新输入'));
      } else {
        callback();
      }
    };
    return {
      form: {
        startTime: '',
        endTime: '',
        paymentCode: '',
        orderId: '',
        status: '',
      },
      statusOptions: [
        // { label: '已取消', value: -1 },
        // { label: '待支付', value: 0 },
        { label: '支付成功', value: 1 },
        // { label: '支付失败', value: 2 },
        { label: '处理中', value: 3 },
        { label: '已完成', value: 4 },
        // { label: '完成失败', value: 5 },
      ],
      formRules: {
        refundAmount: [
          { trigger: ['blur', 'change'], validator: validRefundAmount },
        ],
      },
      timeQuickPickerList: ['今日', '昨日', '本周', '本月'],
      activeIndex: 0,
      pickerOptions: {},
      dateTimeRange: defaultTime,
      exportLoading: false,
      table: {
        loading: false,
        data: [],
        pageNo: 1,
        totalCount: 0,
        pageSize: 10,
      },
      showDetailDialog: false,
      detailLoading: false,
      showRefundDialog: false,
      refundBtnLoading: false,
      detailForm: {},
      detailTable: [],
      refundForm: {
        refundAmount: '',
        id: '',
        lsOrderId: '',
        depositAmountStr: '',
      },
      searchTime: 0,
      loadingObj: {},
      refreshTable: true,
      timer: null,
      notify: {
        show: false,
        message: '',
        color: '',
        type: '',
        num: 5,
        timer: null,
      },
    };
  },
  computed: {
    exportTable() {
      return debounce(this.exportTableFunc, 500, true);
    },
    merchantId() {
      return JSON.parse(window.localStorage.getItem('LOGIN_INFO')).merchantId || null;
    },
    remainMoney() {
      const { depositAmountStr, refundAmount } = this.refundForm;
      const depositAmount = Math.round(parseFloat(depositAmountStr) * 10000);
      const refundAmountStr = Math.round(parseFloat(refundAmount) * 10000);
      const remain = (depositAmount - refundAmountStr) / 10000;
      return refundAmount && refundAmount >= 0 && remain >= 0 ? remain.toFixed(2) : '--';
    },
  },
  mounted() {
    this.queryTableData();
  },
  methods: {
    formatStatus(row, column, cellValue) {
      const obj = {
        1: '支付成功',
        3: '处理中',
        4: '已完成',
        5: '完成失败',
      };
      return obj[cellValue] || '';
    },
    handleQuickTimePickerChange(index) {
      this.activeIndex = index;
      let startTimeRange = startDate;
      let endTimeRange = endDate;
      if (index === 1) {
        startTimeRange = moment().subtract(1, 'd').startOf('d').format(FORMAT);
        endTimeRange = moment(startTimeRange).endOf('d').format(FORMAT);
      } else if (index === 2) {
        startTimeRange = moment().day(1).startOf('d').format(FORMAT);
      } else if (index === 3) {
        startTimeRange = moment().startOf('month').format(FORMAT);
      }
      this.dateTimeRange = [startTimeRange, endTimeRange];
      this.queryTableData();
    },
    handleTimeRangeChange() {
      this.activeIndex = null;
    },
    exportTableFunc() {
      this.handleSetParams((params) => {
        this.exportLoading = true;
        exportOrder(params).then(({ data: { code, data, msg } }) => {
          if (code === '0') {
            this.$message.success('导出成功，请到下载中心下载报表文件！');
          }
        }).finally(() => {
          this.exportLoading = false;
        });
      });
    },
    handleFormReset() {
      this.dateTimeRange = defaultTime;
      this.activeIndex = 0;
      this.form = {
        startTime: '',
        endTime: '',
        paymentCode: '',
        orderId: '',
        status: '',
      };
      this.handleFormSearch();
    },
    handleFormSearch() {
      this.table.pageNo = 1;
      this.queryTableData();
    },
    handleSetParams(callback) {
      [this.form.startTime, this.form.endTime] = this.dateTimeRange || [];
      const params = {
        ...this.form,
        merchantId: this.merchantId,
      };
      callback(params);
    },
    queryTableData() {
      this.handleSetParams((params) => {
        const { pageNo, pageSize } = this.table;
        params = {
          ...params,
          pageNo,
          pageSize,
        };
        this.table.loading = true;
        pageQuery(params).then(({ data: { code, data, msg } }) => {
          if (code === '0') {
            this.table.totalCount = data.totalCount;
            this.table.data = data.list.map((item) => {
              this.loadingObj[item.orderId] = false;
              return item;
            });
          }
        }).finally(() => {
          this.table.loading = false;
        });
      });
    },
    /**
     * 改变当前页事件
     * @param  {number} pageNo 当前页码
     */
    onChangeCurrentPage(pageNo) {
      this.table.pageNo = pageNo;
      this.queryTableData();
    },
    handleTableDetail({ id }, boo) {
      if (boo) {
        this.showDetailDialog = true;
      } else {
        this.showRefundDialog = true;
        this.refundForm.refundAmount = '';
      }
      this.detailLoading = true;
      queryOrderDetail({ id }).then(({ data: { code, data, msg } }) => {
        if (code === '0') {
          this.detailForm = data;
          const {
            refundAmountStr, depositAmountStr, totalAmountStr, lsOrderId,
          } = data;
          if (boo) {
            this.detailTable = [{ refundAmountStr, depositAmountStr, totalAmountStr }];
          } else {
            this.refundForm.id = id;
            this.refundForm.lsOrderId = lsOrderId;
            this.refundForm.depositAmountStr = depositAmountStr;
          }
        }
      }).finally(() => {
        this.detailLoading = false;
      });
    },
    handleTableRefresh({ orderId, flowId }, index) {
      this.setTableLoadingRefresh(orderId, true);
      refreshOrderStatus({ flowId }).then(({ data: { code, data, msg } }) => {
        if (code === '0') {
          this.table.data[index].preProcessStatus = data.status;
          if (data.status === 5) {
            this.$message.warning('退订失败，请重新退订！');
            this.table.data[index].checkOutFlag = 1;
          }
        }
      }).catch(() => {
        this.queryTableData();
      }).finally(() => {
        this.setTableLoadingRefresh(orderId, false);
      });
    },
    setTableLoadingRefresh(orderId, boo) {
      this.$set(this.loadingObj, orderId, boo);
      this.refreshTable = false;
      this.$nextTick(() => {
        this.refreshTable = true;
      });
    },
    handleConfirmRefund() {
      this.$refs.refundForm.validate((valid) => {
        if (valid) {
          const { id, lsOrderId, refundAmount } = this.refundForm;
          const params = {
            merchantId: this.merchantId,
            id,
            lsOrderId,
            refundAmount: Math.round(parseFloat(refundAmount) * 10000) / 100,
          };
          this.refundBtnLoading = true;
          refundOrder(params).then(({ data: { code, data: { flowId }, msg } }) => {
            if (code === '0') {
              this.handleGetOperateRefundResult(flowId);
            }
          }).catch(() => {
            this.handleCancelRefund();
          });
        }
      });
    },
    handleGetOperateRefundResult(flowId) {
      this.searchTime += 1;
      getOperateRefundResult({ flowId }).then(({ data: { code, data, msg } }) => {
        if (code === '0' && this.refundBtnLoading) {
          if (data.status === 4) {
            this.showNotify('success', `交易退订成功！`, '#67c23a');
          } else if (data.status === 5) {
            this.showNotify('error', `退订失败！`, '#f56c6c');
          } else if (this.searchTime === 10) {
            this.showNotify('warning', `交易结果查询超时，请刷新页面后重试！`, '#e6a23c');
          } else {
            this.timer = setTimeout(() => {
              clearTimeout(this.timer);
              this.handleGetOperateRefundResult(flowId);
            }, 2000);
          }
        }
      }).catch(() => {
        this.handleCancelRefund();
      });
    },
    showNotify(type, message, color) {
      this.handleCancelRefund();
      this.notify = {
        show: true, message, type, color,
      };
      if (type === 'success') {
        this.notify.num = 5;
        this.notify.message = `${message}(${this.notify.num}s)`;
        const inter = setInterval(() => {
          this.notify.num -= 1;
          this.notify.message = `${message}(${this.notify.num}s)`;
          if (this.notify.num === 0) {
            clearInterval(inter);
            this.notify.show = false;
          }
        }, 1000);
      }
    },
    handleCancelNotify() {
      this.notify.show = false;
      this.queryTableData();
    },
    handleCancelRefund() {
      this.searchTime = 0;
      this.refundBtnLoading = false;
      this.showRefundDialog = false;
      clearTimeout(this.timer);
      this.timer = null;
    },
  },
};
</script>

<style scoped lang="scss">
.page-container {
  > .header {
    padding-left: 50px;
    background-color: #fff;

    .title {
      position: relative;
      height: 80px;
      font-size: 18px;
      line-height: 80px;
      color: #333;

      &::after {
        position: absolute;
        right: 0;
        bottom: 0;
        left: -50px;
        display: block;
        height: 0;
        content: "";
        border-bottom: 1px solid #f2f3f3;
      }
    }
  }

  .search-form {
    padding: 40px 50px 20px;
    border-bottom: 20px solid #eee;

    .search-form-content {
      /deep/ .el-select,
      /deep/ .el-input {
        width: 210px;
      }
    }

    .time-range-content {
      display: flex;

      .quick-time-picker {
        display: flex;

        .item {
          flex: 1;
          width: 100px;
          min-width: 100px;
          height: 32px;
          margin-right: 14px;
          font-size: 14px;
          line-height: 32px;
          color: #5e5e63;
          text-align: center;
          cursor: pointer;
          border: 1px solid #dde0e7;

          &.active {
            color: #008cff;
            border: 1px solid #008cff;
          }
        }
      }
    }
  }

  .table-container {
    padding: 40px 50px 0;
    background: #fff;

    .pagination-content {
      margin-top: 10px;
      text-align: center;
    }
  }

  .dialog-footer {
    text-align: center;
  }

  .dialog-wrap {
    .title {
      margin-bottom: 10px;
      font-size: 24px;
      font-weight: 500;
      color: #181818;
    }

    /deep/ .el-dialog__header {
      padding: 20px 40px 10px;
      border-bottom: 1px solid #f8f8f8;
    }

    /deep/ .el-dialog__body {
      padding: 0 40px 40px;
      font-size: 14px;
      font-weight: 400;

      .row {
        height: 40px;
        margin-top: 10px;
      }

      .label {
        display: inline-block;
        width: 115px;
        color: #8c8c92;
      }

      .value {
        color: #27364d;
      }

      .copy-btn {
        margin-left: 8px;
      }
    }

    .form-wrap {
      margin-top: 50px;

      /deep/ .el-form-item__label {
        color: #8c8c92;
      }

      /deep/ .el-form-item__content {
        font-size: 20px;
        color: #181818;
      }

      /deep/ .el-input {
        input {
          width: 385px;
          height: 65px;
          font-size: 30px;
          border-radius: 4px;
        }

        input::placeholder {
          font-size: 22px;
        }
      }
    }
  }
}

::v-deep {
  .el-dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: 0 !important;
    transform: translate(-50%, -50%);
  }
}
</style>
